module.exports = __webpack_public_path__ + "static/media/car_animation.9b95ad61.gif";